import React, {useEffect} from 'react'
import {useHistory} from "react-router"
import {useForm} from "react-hook-form"
import { useAlert } from 'react-alert'

import useApi from "../../useApi"
import {putRegistrationQuestionnaire, getRegistrationQuestionnaire} from "../../api"
import {useParams} from "react-router-dom"
import MobileFooter from "../../components/Footer/MobileFooter";
import SectionAside from "../../components/SectionAside";

export default () => {

    const {register, handleSubmit, errors} = useForm();
    let history = useHistory();
    const {id} = useParams();
    const alert = useAlert();
    const [, get] = useApi({alert});
    const [{statusCode}, update] = useApi({alert});

    useEffect(() => {
        get(getRegistrationQuestionnaire(id));
    }, [id]);

    useEffect(() => {
        if (statusCode && statusCode === 200) {
            history.push("/apply/membership/basic/thank-you")
        }
    }, [statusCode]);

    const onSubmit = (formData) => {
        update(putRegistrationQuestionnaire(id, {
                employment: {
                    location: formData.location,
                    jobTitle: formData.jobTitle,
                    company: formData.company,
                    industry: formData.industry
                },
                questionnaireItems: [{
                    question: "How would you describe your life's mission and your boldest aspirations?",
                    answer: formData.a1,
                    key: "a1"
                }, {
                    question: "What are your areas of expertise? (What superpowers do you have? What do others say makes you amazing?)",
                    answer: formData.a2,
                    key: "a2"
                }, {
                    question: "What types of opportunities would further your mission? (Give us your personal growth wish list!)",
                    answer: formData.a3,
                    key: "a3"
                }, {
                    question: "Who would you like to have dinner with to further your mission? (Pick any 3 people in the world; don't hold back!)",
                    answer: formData.a4,
                    key: "a4"
                }]
            }
        ))
    };

    const getFieldClassName = (err) => {
        return `field${err ? " field--error" : ""}`;
    };

    return (
        <section className="section-form">
            <div className="section__outer">
                <SectionAside title="Thank you for joining The Room!"/>

                <div className="section__content">
                    <div className="section__content-inner">
                        <div className="form">
                            <div className="form__inner">
                                <h2 className="form__title">Please tell us more about you</h2>

                                <div className="form__body">
                                    <form onSubmit={handleSubmit(onSubmit)}>
                                        <div className="form__row">
                                            <label htmlFor="location" className="form__label">Location</label>
                                            <div className="form__controls">
                                                <input className={getFieldClassName(errors.location)}
                                                       id="location" name="location"
                                                       ref={register({required: true})}/>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <label htmlFor="jobTitle" className="form__label">Job Title</label>
                                            <div className="form__controls">
                                                <input className={getFieldClassName(errors.jobTitle)}
                                                       id="jobTitle" name="jobTitle"
                                                       ref={register({required: true})}/>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <label htmlFor="company" className="form__label">Company</label>
                                            <div className="form__controls">
                                                <input className={getFieldClassName(errors.company)}
                                                       id="company" name="company"
                                                       ref={register({required: true})}/>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <label htmlFor="industry" className="form__label">Industry</label>
                                            <div className="form__controls">
                                                <input className={getFieldClassName(errors.industry)}
                                                       id="industry" name="industry"
                                                       ref={register({required: true})}/>
                                            </div>
                                        </div>


                                        <div className="form__row">
                                            <label htmlFor="textarea-1" className="form__label">DESCRIBE YOUR LIFE’S
                                                MISSION AND BOLDEST ASPIRATIONS?</label>
                                            <div className="form__controls">
                                                <textarea id="textarea-1" className="textarea"
                                                          placeholder="How would you describe your life's mission and your boldest aspirations?"
                                                          name="a1" ref={register}/>
                                            </div>
                                        </div>

                                        <div className="form__row">
                                            <label htmlFor="textarea-2" className="form__label">WHAT ARE YOUR AREAS OF
                                                EXPERTISE?</label>
                                            <div className="form__controls">
                                                <textarea id="textarea-2" className="textarea"
                                                          placeholder="What superpowers do you have? What do others say makes you amazing?"
                                                          name="a2" ref={register}/>
                                            </div>
                                        </div>

                                        <div className="form__row">
                                            <label htmlFor="textarea-3" className="form__label">What types of
                                                opportunities would further your mission?</label>
                                            <div className="form__controls">
                                                <textarea id="textarea-3" className="textarea"
                                                          placeholder="Give us your personal growth wish list!"
                                                          name="a3" ref={register}/>
                                            </div>
                                        </div>

                                        <div className="form__row">
                                            <label htmlFor="textarea-4" className="form__label">Who would you like to
                                                have dinner with to further your mission?</label>
                                            <div className="form__controls">
                                                <textarea id="textarea-4" className="textarea"
                                                          placeholder="Pick any 3 people in the world; don't hold back!"
                                                          name="a4" ref={register}/>
                                            </div>
                                        </div>

                                        <div className="form__actions form__actions--pt">
                                            <button type="submit" className="btn__form btn__form--large">submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <MobileFooter/>
                    </div>
                </div>
            </div>
        </section>
    );
}